
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("8Z78B", function(module, exports) {
/**
 * @generated SignedSource<<abe1bfe242e74d4385961078bad185f8>>
 * @relayHash 56e1784a86c45537dbf4ab9c8bb1ffba
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 3ede45193d2890af963c0f976a0d18fc9abdbe45ed83b2480c2ca3bfd8e0f7d7
const $38160060fa19c5ea$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "key"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "key"
                }
            ],
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "onboardingState",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "onboardingStateGetOnboardingStateQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "onboardingStateGetOnboardingStateQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "56e1784a86c45537dbf4ab9c8bb1ffba",
            "id": "3ede45193d2890af963c0f976a0d18fc9abdbe45ed83b2480c2ca3bfd8e0f7d7",
            "metadata": {},
            "name": "onboardingStateGetOnboardingStateQuery",
            "operationKind": "query",
            "text": "query onboardingStateGetOnboardingStateQuery($key:[String]){onboardingState(key:$key){key,value}}"
        }
    };
}();
$38160060fa19c5ea$var$node.hash = "201bff99b2bdca3d23c658876502ced3";
var $38160060fa19c5ea$export$2e2bcd8739ae039 = $38160060fa19c5ea$var$node;
module.exports["default"] = $38160060fa19c5ea$export$2e2bcd8739ae039;

});

parcelRegister("ivb8S", function(module, exports) {

var $209pV = parcelRequire("209pV");


var $42omo = parcelRequire("42omo");


var $7Sm4c = parcelRequire("7Sm4c");


var $8Lx5S = parcelRequire("8Lx5S");


var $6mKj3 = parcelRequire("6mKj3");


var $jMyy4 = parcelRequire("jMyy4");


var $dPJCf = parcelRequire("dPJCf");


var $1NBp8 = parcelRequire("1NBp8");


var $l1uFv = parcelRequire("l1uFv");


var $fEmGS = parcelRequire("fEmGS");


var $308Wd = parcelRequire("308Wd");


var $ij4CE = parcelRequire("ij4CE");


var $cbOce = parcelRequire("cbOce");


var $1cHqV = parcelRequire("1cHqV");


var $8Z78B = parcelRequire("8Z78B");

const $6fc4b7bb962289cc$var$isOnboardingStateEqual = (a, b)=>{
    if (a === b) return true;
    if (!a || !b) return !a && !b;
    if (a.length !== b.length) return false;
    return a.every((item, i)=>item.key === b[i].key && item.value === b[i].value);
};
// Hook to check if we're on a view page route
const $6fc4b7bb962289cc$var$useIsViewPageRoute = ()=>(0, $dPJCf.useRouteName)({
        selector: (routeName)=>routeName === (0, $1NBp8.VIEW_PAGE).name || routeName === (0, $1NBp8.VIEW_BLOG).name || routeName === (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).name
    });
// Get the combined onboarding state from cache, returns null if not cached
const $6fc4b7bb962289cc$var$getCombinedQueryFromCache = ()=>{
    try {
        return (0, $l1uFv.readQueryInterop)({
            query: (0, $8Z78B.default),
            variables: {
                key: []
            },
            __callerPackage__: "onboarding-helpers"
        });
    } catch  {
        return null;
    }
};
// Updates the combined query cache with new onboarding state values.
// This ensures components using the centralized cache see updates on next mount/navigation.
const $6fc4b7bb962289cc$var$updateCombinedQueryCache = (updatedStates)=>{
    if (!(0, $6mKj3.expVal)('confluence_centralized_onboarding_state', 'isEnabled', false)) return;
    const currentData = $6fc4b7bb962289cc$var$getCombinedQueryFromCache();
    if (!currentData?.onboardingState) return;
    const updatedMap = new Map(updatedStates.map((s)=>[
            s.key,
            s.value
        ]));
    const newOnboardingState = currentData.onboardingState.map((item)=>updatedMap.has(item.key) ? {
            ...item,
            value: updatedMap.get(item.key) ?? item.value
        } : item);
    (0, $fEmGS.writeQueryInterop)({
        query: (0, $8Z78B.default),
        variables: {
            key: []
        },
        data: {
            onboardingState: newOnboardingState
        },
        __callerPackage__: "onboarding-helpers"
    });
};
const $6fc4b7bb962289cc$export$7ca8667598519375 = (data)=>{
    const state = {};
    // new graphQL call returns onboardingState array
    const { onboardingState: onboardingState } = data || {};
    // parse data and populate state accordingly
    if (onboardingState !== undefined && onboardingState !== null) for (const { key: key, value: value } of onboardingState){
        // key comes back as "{prefix}:{property}" format
        // split by ':' to get parsed {property}
        // some keys don't have a prefix, which is why we have the ||
        const parsedKey = key.split(':')[1] || key;
        if (!value) continue;
        if (/(true|false)/g.test(value)) state[parsedKey] = value === 'true';
        else state[parsedKey] = value;
    }
    return state;
};
const $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf = ()=>{
    const [setState, { error: error, called: called }] = (0, $308Wd.useMutationInterop)((0, $209pV.default), {
        update (_cache, { data: data }) {
            const states = data.setOnboardingState;
            (states ?? []).forEach(({ key: key, value: value })=>{
                // writeFragment can only handle a single data item at a time
                (0, $ij4CE.writeFragmentInterop)({
                    fragmentId: `OnboardingState:${key}`,
                    data: {
                        key: key,
                        value: value ?? null,
                        __typename: 'OnboardingState'
                    },
                    __callerPackage__: "onboarding-helpers"
                });
            });
            // Update the combined query cache for centralized onboarding state
            $6fc4b7bb962289cc$var$updateCombinedQueryCache(states ?? []);
        },
        onError: (error)=>{
            if ((0, $cbOce.isExpectedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
        },
        __callerPackage__: "onboarding-helpers"
    });
    const setOnboardingState = (0, $42omo.useCallback)((newOnboardingState)=>{
        let states;
        if (Array.isArray(newOnboardingState)) // supports batch updates
        states = newOnboardingState;
        else // backwards compability for single key-value pair
        states = [
            newOnboardingState
        ];
        setState({
            variables: {
                states: states
            },
            optimisticResponse: {
                setOnboardingState: states.map(({ key: key, value: value })=>({
                        key: key,
                        value: value,
                        __typename: 'OnboardingState'
                    }))
            }
        });
    }, [
        setState
    ]);
    return {
        setOnboardingState: setOnboardingState,
        error: error,
        called: called
    };
};
// safeguards against empty arrays or strings
const $6fc4b7bb962289cc$var$hasValidKeysToFetch = (key)=>{
    if (Array.isArray(key)) return key.length > 0;
    if (typeof key === 'string') return key.length > 0;
    return false;
};
const $6fc4b7bb962289cc$export$d5e7611ac338ec84 = (key, skip = false, reactive = true)=>{
    const { isLicensed: isLicensed, isGuest: isGuest } = (0, $8Lx5S.useAccessStatus)();
    const isAllowed = isLicensed || isGuest;
    const isViewPageRoute = $6fc4b7bb962289cc$var$useIsViewPageRoute();
    const hasKeysToFetch = $6fc4b7bb962289cc$var$hasValidKeysToFetch(key);
    const skipQuery = skip || !isAllowed || !hasKeysToFetch;
    // Check if centralized cache should be used (experiment enabled + on view page route)
    const useCentralizedCache = isViewPageRoute && (0, $6mKj3.expVal)('confluence_centralized_onboarding_state', 'isEnabled', false);
    // For non-reactive mode: read from cache once (no subscription)
    // This is a one-time synchronous read that doesn't trigger re-renders on cache changes
    const cachedCombinedData = !reactive && useCentralizedCache ? $6fc4b7bb962289cc$var$getCombinedQueryFromCache() : null;
    const hasCachedCombinedData = cachedCombinedData !== null;
    // For reactive mode: use useQueryInterop with cache-only to subscribe to cache changes
    // This subscribes to the centralized cache and re-renders when it changes (no network requests)
    const { data: reactiveCacheData, error: reactiveCacheError, loading: reactiveCacheLoading } = (0, $jMyy4.useQueryInterop)((0, $8Z78B.default), {
        variables: {
            key: []
        },
        skip: skipQuery || !reactive || !useCentralizedCache,
        fetchPolicy: 'cache-only',
        __callerPackage__: "onboarding-helpers"
    });
    // Memoize the filtered reactive cache result so filterOnboardingState is only called
    // when reactiveCacheData or key actually changes — not on every render.
    //
    // We must not skip the fallback just because reactiveCacheData is truthy — the centralized
    // cache may not contain the specific keys this consumer requested (e.g. the preload fetched
    // a different set of keys). We only skip the fallback when the filtered reactive cache data
    // actually has entries for the requested keys.
    const { reactiveFilteredData: reactiveFilteredData, reactiveFilteredHasData: reactiveFilteredHasData } = (0, $42omo.useMemo)(()=>{
        if (!(reactive && useCentralizedCache && reactiveCacheData)) return {
            reactiveFilteredData: null,
            reactiveFilteredHasData: false
        };
        const filtered = (0, $1cHqV.filterOnboardingState)(reactiveCacheData, key);
        return {
            reactiveFilteredData: filtered,
            reactiveFilteredHasData: (filtered?.onboardingState?.length ?? 0) > 0
        };
    }, [
        reactive,
        useCentralizedCache,
        reactiveCacheData,
        key
    ]);
    const { data: fallbackQueryData, error: fallbackError, loading: fallbackLoading, refetch: refetch } = (0, $jMyy4.useQueryInterop)((0, $8Z78B.default), {
        variables: {
            key: key
        },
        skip: skipQuery || hasCachedCombinedData || reactiveFilteredHasData,
        __callerPackage__: "onboarding-helpers"
    });
    // Determine which data source to use:
    // 1. Non-reactive with cached data: use cachedCombinedData (filtered)
    // 2. Reactive with centralized cache and keys found: use reactiveFilteredData
    // 3. Fallback: use fallbackQueryData
    // For reactive path: skip re-render if filtered data for our keys hasn't changed
    const prevFilteredDataRef = (0, $42omo.useRef)(undefined);
    const data = (0, $42omo.useMemo)(()=>{
        if (hasCachedCombinedData) return (0, $1cHqV.filterOnboardingState)(cachedCombinedData, key);
        if (reactiveFilteredHasData && reactiveFilteredData) {
            if (prevFilteredDataRef.current && $6fc4b7bb962289cc$var$isOnboardingStateEqual(prevFilteredDataRef.current.onboardingState, reactiveFilteredData.onboardingState)) return prevFilteredDataRef.current;
            prevFilteredDataRef.current = reactiveFilteredData;
            return reactiveFilteredData;
        }
        return fallbackQueryData;
    }, [
        hasCachedCombinedData,
        cachedCombinedData,
        reactiveFilteredHasData,
        reactiveFilteredData,
        fallbackQueryData,
        key
    ]);
    // Combine error and loading states from both queries
    const error = reactiveCacheError || fallbackError;
    // When centralized cache is enabled in reactive mode but the preload hasn't populated
    // the cache yet, cache-only returns loading: false with data: undefined. Without this
    // guard, consumers interpret undefined data as "user never saw this onboarding" and
    // incorrectly show spotlights/changeboarding that was already dismissed.
    // We report loading: true until either the reactive cache or fallback has actual data.
    //
    // Also guard the case where the reactive cache is populated but doesn't contain the
    // specific keys this consumer requested (reactiveFilteredHasData is false). In that
    // scenario the fallback query has been allowed to run — keep loading: true until it
    // either returns data or an error, so consumers don't prematurely see empty state.
    const isCentralizedCacheWaitingForPreload = reactive && useCentralizedCache && (!reactiveCacheData || !reactiveFilteredHasData) && !fallbackQueryData && !skipQuery && !reactiveCacheError && !fallbackError;
    const loading = isCentralizedCacheWaitingForPreload || (reactive && useCentralizedCache ? reactiveCacheLoading : false) || fallbackLoading;
    return {
        data: data,
        error: error,
        loading: loading,
        refetch: refetch
    };
};
module.exports["deserializeState"] = $6fc4b7bb962289cc$export$7ca8667598519375;
module.exports["useSetOnboardingState"] = $6fc4b7bb962289cc$export$c5bcaee8a4aee6cf;
module.exports["useGetOnboardingState"] = $6fc4b7bb962289cc$export$d5e7611ac338ec84;

});

parcelRegister("209pV", function(module, exports) {
/**
 * @generated SignedSource<<a83598c413cebc1d8cb2388f4b0ca41c>>
 * @relayHash 3faa5f50f8c511a1bae008881ee58062
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1c2e262362f2b7a2909940b7e6956cbd2cb7f92d9a44abb1caff1c81d7518bed
const $4f605ad876f6c5d9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "states"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "states",
                    "variableName": "states"
                }
            ],
            "concreteType": "OnboardingState",
            "kind": "LinkedField",
            "name": "setOnboardingState",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "key"
                },
                {
                    "kind": "ScalarField",
                    "name": "value"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "onboardingStateSetOnboardingStateMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "onboardingStateSetOnboardingStateMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "3faa5f50f8c511a1bae008881ee58062",
            "id": "1c2e262362f2b7a2909940b7e6956cbd2cb7f92d9a44abb1caff1c81d7518bed",
            "metadata": {},
            "name": "onboardingStateSetOnboardingStateMutation",
            "operationKind": "mutation",
            "text": "mutation onboardingStateSetOnboardingStateMutation($states:[OnboardingStateInput!]!){setOnboardingState(states:$states){key,value}}"
        }
    };
}();
$4f605ad876f6c5d9$var$node.hash = "90b0af82da00eefb44f28228419e7c9e";
var $4f605ad876f6c5d9$export$2e2bcd8739ae039 = $4f605ad876f6c5d9$var$node;
module.exports["default"] = $4f605ad876f6c5d9$export$2e2bcd8739ae039;

});

parcelRegister("8Lx5S", function(module, exports) {

var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");

/**
 * Checks if the user has any licensed access (either admin or use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin or use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensed = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user has licensed admin access.
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed admin access, otherwise false.
 */ const $30f02aa82d7102bc$var$isAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS;
};
/**
 * Checks if the user has licensed non-admin access (use access).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user has licensed use access, otherwise false.
 */ const $30f02aa82d7102bc$var$isLicensedNonAdmin = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
};
/**
 * Checks if the user is a guest (external collaborator).
 *
 * @param {AccessStatus | null} accessStatus - The access status of the user.
 * @returns {boolean} - Returns true if the user is an external collaborator, otherwise false.
 */ const $30f02aa82d7102bc$var$isGuest = (accessStatus)=>{
    return accessStatus === (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS;
};
const $30f02aa82d7102bc$export$ac4f65b11c57a33b = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensed(accessStatus);
};
const $30f02aa82d7102bc$export$99a5e4bc80d231ca = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$a67466804611d2db = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus);
};
const $30f02aa82d7102bc$export$f9ffae90e66d63e = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return $30f02aa82d7102bc$var$isGuest(accessStatus);
};
const $30f02aa82d7102bc$export$41f8700aabec6a40 = ()=>{
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    return {
        isGuest: $30f02aa82d7102bc$var$isGuest(accessStatus),
        isLicensed: $30f02aa82d7102bc$var$isLicensed(accessStatus),
        isAdmin: $30f02aa82d7102bc$var$isAdmin(accessStatus),
        isLicensedNonAdmin: $30f02aa82d7102bc$var$isLicensedNonAdmin(accessStatus)
    };
};
module.exports["useIsLicensed"] = $30f02aa82d7102bc$export$ac4f65b11c57a33b;
module.exports["useIsAdmin"] = $30f02aa82d7102bc$export$99a5e4bc80d231ca;
module.exports["useIsGuest"] = $30f02aa82d7102bc$export$f9ffae90e66d63e;
module.exports["useAccessStatus"] = $30f02aa82d7102bc$export$41f8700aabec6a40;

});

parcelRegister("cbOce", function(module, exports) {

var $6fil2 = parcelRequire("6fil2");


var $1uFM6 = parcelRequire("1uFM6");

function $2f49c1e50cca9335$export$8715824c16ceeca0(error) {
    const isUnauthorized = error?.graphQLErrors?.[0]?.message === 'unauthorized' || (0, $1uFM6.isUnauthorizedError)(error);
    return isUnauthorized || (0, $6fil2.containsNetworkError)(error);
}
module.exports["isExpectedError"] = $2f49c1e50cca9335$export$8715824c16ceeca0;

});

parcelRegister("1cHqV", function(module, exports) {
// Cache for filtered onboarding state results.
// Uses WeakMap keyed by data object (auto-clears when data is garbage collected),
// with nested Map keyed by keys string for O(1) lookup.
const $e7b7b792910c4288$var$filteredStateCache = new WeakMap();
/**
 * Creates a cache key from the requested keys.
 */ const $e7b7b792910c4288$var$createCacheKey = (keys)=>{
    return Array.isArray(keys) ? keys.join(',') : keys;
};
/**
 * Performs the actual filtering of onboarding state data.
 */ const $e7b7b792910c4288$var$filterData = (data, requestedKeys)=>{
    const keysArray = Array.isArray(requestedKeys) ? requestedKeys : [
        requestedKeys
    ];
    const keySet = new Set(keysArray);
    return {
        ...data,
        onboardingState: data.onboardingState?.filter(({ key: key })=>{
            // Check both the full key and the parsed key (without prefix)
            // Keys come back as "{prefix}:{property}" format
            const parsedKey = key.split(':')[1] || key;
            return keySet.has(key) || keySet.has(parsedKey);
        })
    };
};
const $e7b7b792910c4288$export$c1dd389f39afa62f = (data, requestedKeys)=>{
    if (!data?.onboardingState) // Convert null to undefined to maintain backward compatibility with consumers
    // that expect `T | undefined` rather than `T | null | undefined`
    return data ?? undefined;
    const cacheKey = $e7b7b792910c4288$var$createCacheKey(requestedKeys);
    let dataCache = $e7b7b792910c4288$var$filteredStateCache.get(data);
    if (!dataCache) {
        dataCache = new Map();
        $e7b7b792910c4288$var$filteredStateCache.set(data, dataCache);
    }
    if (dataCache.has(cacheKey)) return dataCache.get(cacheKey);
    const filteredResult = $e7b7b792910c4288$var$filterData(data, requestedKeys);
    dataCache.set(cacheKey, filteredResult);
    return filteredResult;
};
module.exports["filterOnboardingState"] = $e7b7b792910c4288$export$c1dd389f39afa62f;

});


//# sourceMappingURL=NativeCollabComponent.c780ca8b.js.map
